<template>
    <full-screen-panel :show-on-mobile="showOnMobile">
        <full-screen-panel-content class="p-8 pr-0 pt-8">
            <div :class="['flex flex-col flex-1 p-6 bg-white shadow-3xl overflow-y-auto overflow-x-hidden h-full', classList]">
                <slot />
            </div>
        </full-screen-panel-content>
    </full-screen-panel>
</template>

<script>
    import FullScreenPanel from '../FullScreenPanel.vue';
    import FullScreenPanelContent from '../FullScreenPanelContent.vue';

    export default {
        components: {
            FullScreenPanel,
            FullScreenPanelContent,
        },
        props: {
            showOnMobile: {
                type: Boolean,
                default: false,
            },
            classList: {
                type: String,
                default: '',
            },
        },
        computed: {
            selectedStep() {
                return this.$store.state.selectedStep;
            },
        },
        methods: {
            afterEnterTransition() {
                this.$store.dispatch('globalEvent', {
                    event: 'secondaryEntered',
                });
            },
        },
    };
</script>
